angular.module('qkr').directive('variantName', () => ({

        restrict: 'A',
        require: 'ngModel',

        template: '<span> {{text}}</span>',

        link(scope, element, attrs, ngModel) {
            scope.$watch(ngModel.$modelValue, (oldValue, newValue) => {
                scope.text = '';
                angular.forEach(ngModel.$modelValue.variantDetails, (variantDetail) => {
                    scope.text += variantDetail.variantValue + ', ';
                });

                scope.fullText = scope.text;
                scope.text = scope.text.substring(0, scope.text.length - 2);
            });
        }
    }));



// WEBPACK FOOTER //
// ./src/directives/product/variant_detail_name.js